import endPoints from 'utils/endPoints';
import { PostMutate } from 'utils/mutationAndQuery/customMutation';
import { FetchAllData, FetchData } from 'utils/mutationAndQuery/customUseQuery';

export const requestSupportedLanguage = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.supportedLanguage,
  });
  return {
    isLoading,
    languages: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};

export const fetchTranslation = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.fetchLangTranslation,
  });
  return {
    message: data?.message,
    languageData: data?.data ?? [],
    isLoadingLanguage: isLoading,
    isSuccess,
  };
};

export const setDefaultLanguage = () => {
  const { data, isPending, mutate, isSuccess } = PostMutate(endPoints.setLang);
  const languageData = data;

  if (Array.isArray(languageData)) {
    return {
      isLoadingLanguage: isPending,
      languageData: languageData || [],
      submitData: mutate,
      isSuccess,
    };
  } else {
    return {
      isLoadingLanguage: isPending,
      languageData: [],
      submitData: mutate,
      isSuccess,
    };
  }
};


